const CommunityPostEditorInfoBox = ({ userNm, universityNm, regDttm }) => {
    return (
        <div className='cmnty-file-box'>
            <div className='post-editer-box'>
                <div className='editer-detail'>
                    <div className='detail-set'>
                        <div className='cate'>등록자</div>
                        <div className='data'>{userNm}</div>
                    </div>
                    <div className='detail-set'>
                        <div className='cate'>소속대학</div>
                        <div className='data'>{universityNm}</div>
                    </div>
                    <div className='detail-set'>
                        <div className='cate'>등록일자</div>
                        <div className='data'>{regDttm}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommunityPostEditorInfoBox;
